export enum MatomoCategory {
    MFA = 'MFA',
}

export class Matomo {
    static push(category: string, action: string, value: any = undefined) {
        if (typeof (window as any)._paq !== 'undefined') {
            (window as any)._paq.push(['trackEvent', category, action, value]);
        }
    }
}
